
import { Component, Prop, Vue } from 'vue-property-decorator';
import { aliasInfoType, form12PartiesInfoType, form12PartiesStatesInfoType, representativeInfoType } from '@/types/Information/Form12';

import AddAliasForm from '@/components/process/Form1/components/fillForm1/AddAliasForm.vue';
import AddRepresentativeForm from '@/components/process/Form1/components/fillForm1/AddRepresentativeForm.vue';
import {getPartyTitles, getFullName} from "./PartyTitlesForm12"

@Component({
    components:{        
        AddAliasForm,
        AddRepresentativeForm  
    }
})
export default class AddPartyModal extends Vue {

    @Prop({required:true})
    isCreate: boolean;

    @Prop({required:true})
    party: form12PartiesInfoType;

    partyStates= {} as form12PartiesStatesInfoType;

    partyTypeOptions = [
        {text: 'an individual', value: false},
        {text: 'an organization', value: true}
    ];

    aliasFields = [
        {
            key:'nameType',          
            label:'Alias Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Alias Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    representativeFields = [
        {
            key:'repType',          
            label:'Representative Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Representative Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    AddNewAliasForm = false;       
    addAliasFormColor = 'court';
    latestEditAliasData;
    isEditAliasOpen = false;

    AddNewRepresentativeForm = false; 
    addRepresentativeFormColor = 'court';
    latestEditRepresentativeData;
    isEditRepresentativeOpen = false;

    update = 0;
    originalParty = {} as form12PartiesInfoType

    mounted(){
        this.initPartyStates()
        if(this.isCreate){
            this.prepopulateParty()
        }else{
            this.originalParty = JSON.parse(JSON.stringify(this.party))
        }
    }

    public initPartyStates(){
        this.partyStates.firstName = null
        this.partyStates.lastName = null
        this.partyStates.organizationName = null
        this.partyStates.counselName = null
        this.partyStates.type = null
        this.update++;
    }

    public prepopulateParty(){
        this.party.isOrganization = null
        this.party.firstName = null
        this.party.lastName = null
        this.party.organization = null
        this.party.name = null
        this.party.title = null
        this.party.counselName = null
        this.party.aliases = []
        this.party.legalReps = []
        this.update++;
    }

    public checkPartyStates(){

        let stateCheck = true;
        this.partyStates.type = (this.party.isOrganization == null)? false :null
        
        if (this.party.isOrganization){
            this.partyStates.organizationName = !(this.party.organization)? false : null;
        } else {
            this.partyStates.lastName = !(this.party.lastName)? false : null;
            this.partyStates.firstName = !(this.party.firstName)? false : null;
        }

        for(const field of Object.keys(this.partyStates)){
            if(this.partyStates[field]==false)
                stateCheck = false;
        }
        this.update++;
        return stateCheck;            
    }

    public addNewAlias(){
        if(this.isEditAliasOpen){            
            this.addAliasFormColor = 'danger'
        }else{
            this.AddNewAliasForm = true;            
        }
    }

    public addNewRepresentative(){
        if(this.isEditRepresentativeOpen){            
            this.addRepresentativeFormColor = 'danger'
        }else{
            this.AddNewRepresentativeForm = true;            
        }
    }

    public modifyAliasList(isCreateAlias: boolean, newAlias: aliasInfoType, index: number){        

        if (isCreateAlias){
            if(this.party.aliases)           
                this.party.aliases.push(newAlias)
            else
                this.party.aliases=[newAlias]
            this.closeAliasForm();
        } else {           
            this.party.aliases[index].nameType = newAlias.nameType;
            this.party.aliases[index].name = newAlias.name;           
            this.closeAliasForm();
        }        
    }

    public removeAlias(data){        
        this.party.aliases.splice(data.index,1);      
    }

    public modifyRepresentativeList(isCreateRep: boolean, newRepresentative: representativeInfoType, index: number){       

        if (isCreateRep){ 
            if(this.party.legalReps)          
                this.party.legalReps.push(newRepresentative)
            else
                this.party.legalReps=[newRepresentative]
            this.closeRepresentativeForm();
        } else {           
            this.party.legalReps[index].repType = newRepresentative.repType;
            this.party.legalReps[index].name = newRepresentative.name;           
            this.closeRepresentativeForm();
        }      
    }

    public removeRepresentative(data){
        this.party.legalReps.splice(data.index,1);
    }

    public editAlias(data) {
        if(this.AddNewAliasForm || this.isEditAliasOpen){            
            this.addAliasFormColor = 'danger';                     
        }else if(!this.isEditAliasOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAliasOpen = true;
            this.latestEditAliasData = data            
        }   
    }

    public editRepresentative(data) {
        if(this.AddNewRepresentativeForm || this.isEditRepresentativeOpen){            
            this.addRepresentativeFormColor = 'danger';                     
        }else if(!this.isEditRepresentativeOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditRepresentativeOpen = true;
            this.latestEditRepresentativeData = data;            
        }   
    }

    public closeAliasForm() {                     
        this.AddNewAliasForm= false; 
        this.addAliasFormColor = 'court'
        if(this.isEditAliasOpen){
            this.latestEditAliasData.toggleDetails();
            this.isEditAliasOpen = false;
        } 
    }

    public closeRepresentativeForm() {                     
        this.AddNewRepresentativeForm= false; 
        this.addRepresentativeFormColor = 'court'
        if(this.isEditRepresentativeOpen){
            this.latestEditRepresentativeData.toggleDetails();
            this.isEditRepresentativeOpen = false;
        } 
    }

    public closeModal(){
        for(const field of Object.keys(this.party)){
            this.party[field] = this.originalParty[field]
        }
        this.$emit('partyChanged',false)
    }

    public saveParty(){
        if(this.checkPartyStates()){
            this.party.name = getFullName(this.party);
            this.party.title = getPartyTitles(this.party, '</br>');
            //console.log(this.party)
            if(this.isCreate)
                this.$emit('partyChanged',true)
            else
                this.$emit('partyChanged',false)
        }
    }


}
